<template>
    <div>
        <h2 class="mb-8">{{ __('general.package_dimension_presets') }}</h2>
        <div class="table-responsive">
            <table class="table table-hover table-vertical-center">
                <thead>
                <tr>
                    <th>{{ __('general.name') }}</th>
                    <th class="text-center">{{ __('general.width') }}</th>
                    <th class="d-none d-md-table-cell"></th>
                    <th class="text-center">{{ __('general.height') }}</th>
                    <th class="d-none d-md-table-cell"></th>
                    <th class="text-center">{{ __('general.length') }}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="preset in presets">
                    <td>{{ preset.name }}</td>
                    <td class="text-center">
                        {{ preset.dimensions.width.value }}&nbsp;{{ preset.dimensions.width.unit }}
                    </td>
                    <td class="text-center d-none d-md-table-cell">x</td>
                    <td class="text-center">
                        {{ preset.dimensions.height.value }}&nbsp;{{ preset.dimensions.height.unit }}
                    </td>
                    <td class="text-center d-none d-md-table-cell">x</td>
                    <td class="text-center">
                        {{ preset.dimensions.length.value }}&nbsp;{{ preset.dimensions.length.unit }}
                    </td>
                    <td class="text-right text-nowrap">
                        <div class="d-flex flex-row justify-content-end align-items-center gap-1">
                            <!--                            <a href="" class="btn btn-sm btn-link btn-hover-primary text-decoration-none">-->
                            <!--                                <i class="fas fa-edit"/>-->
                            <!--                                {{ __('actions.edit') }}-->
                            <!--                            </a>-->
                            <button class="btn btn-sm btn-link btn-hover-danger text-decoration-none"
                                    @click="deletePreset(preset.name)">
                                <i class="fas fa-trash"/>
                                {{ __('actions.delete') }}
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="mt-3">
            <button class="btn btn-light-primary" @click="createNewVisible = true"
            >
                <i class="fas fa-plus-square"/>
                Create dimension preset
            </button>
        </div>

        <CreatePackageDimensionPresetModal :visible="createNewVisible"
                                           :store-uuid="storeUuid"
                                           @hide="createNewVisible = false"
        />
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import Modal from "@components/Modal.vue";
import FormErrors from "@components/Form/FormErrors.vue";
import CreatePackageDimensionPresetModal from "@components/Packages/CreatePackageDimensionPresetModal.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {CreatePackageDimensionPresetModal, FormErrors, Modal, Link},

    layout: Navigation,

    props: {
        storeUuid: String,
        presets: Array
    },

    data() {
        return {
            createNewVisible: false
        }
    },

    methods: {
        deletePreset(presetName) {
            let vue = this;
            Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-secondary"
                },
                buttonsStyling: false
            }).fire({
                title: this.__('actions.remove_thing', {thing: this.__('general.package_dimension_presets')}) + '?',
                text: presetName,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: this.__('actions.delete'),
                cancelButtonText: this.__('actions.abort'),
            }).then(function (result) {
                if (result.value) {
                    vue.$inertia.delete(vue.$route('store.package_dimension_presets.delete', [vue.storeUuid, presetName]));
                    toastr.warning(presetName + ' ' + vue.__('general.deleted').toLowerCase());
                }
            });
        }
    }
}
</script>
